<riv-checkbox
  [value]="selected | async"
  (valueChange)="doSelect.next($event)"
  [identifier]="UUID"
  [name]="UUID"
  [disabled]="checkboxDisabled"
  class="rv-left sticky-left"
></riv-checkbox>
